// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signin_navigation {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 20px;
    width: 50%;
    margin: auto;
    font-size: 16px;
    font-weight: 700;
}

.signin_active {
    position: relative;
    /* OBLIGATOIRE */
    color: var(--couleur-secondaire);
}

.signin_active::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -6px;
    width: 80%;
    height: 3px;
    background-color: var(--couleur-secondaire);
    transform: translateX(-50%);
}

.signin_welcome {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
}

.signign_welcom h1 {
    font-size: 32px;
    font-weight: 700;
    color: var(--couleur-dark);
}

.signin_welcome p {
    font-size: 16px;
    margin-bottom: 10px;
    color: var(--couleur-principale);
}


.signin_social_buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
}

.signin_social_buttons button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 10px;
    border-radius: 10px;
    border: solid 1px var(--gris-secondaire);
    background-color: var(--gris-secondaire);
    cursor: pointer;
    width: 50%;
    color: var(--couleur-dark);
    height: 58px;
    border-radius: 100px;
    font-size: 16px;
    font-weight: 400;
}

.signin_social_buttons button img {
    width: 20px;
    height: 20px;
}

.signin_form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 50%;
    margin: auto;
}

.signin_form p,
span {
    font-size: 14px;
    color: var(--couleur-dark);
    margin-left: 10px;
    font-weight: 400;
}

.signin_radio_group {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
    width: 50%;
}

.signin_input_text {
    padding: 15px;
    border-radius: 100px;
    border: solid 1px var(--gris-principale);
    font-size: 16px;
}

.sigin_validate {
    background-color: var(--couleur-principale);
    border: solid 2px var(--couleur-principale);
    border-radius: 100px;
    padding: 10px;
    color: var(--white-principale);
    margin-top: 20px;
    cursor: pointer;
    font-size: 16px;
}

.sigin_validate:hover {
    background-color: var(--couleur-secondaire);
    border: solid 2px var(--couleur-secondaire);
}

.signin_hr {
    width: 50%;
    color: var(--couleur-dark);
    margin: auto;
    margin-bottom: 40px;
    margin-top: 40px;
}

.signin_icon_x {
    position: absolute;
    top: 40px;
    right: 100px;
    font-size: 28px;
    color: var(--couleur-secondaire);
}

input[type="radio"] {
    transform: scale(1.4);
    cursor: pointer;
    accent-color: var(--couleur-secondaire);
}

@media (max-width: 769px) {
    .signin_navigation {
        width: 100%;
    }
    .signin_navigation div{
        margin: 5px;
    }
    .signin_social_buttons button {
        width: 100%;
    }

    .signin_form {
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
    }

    .signin_icon_x {
        top: 5px;
        right: 5px;
    }
}

@media (max-width: 992px) {
    .signin_navigation {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/authentification/signin.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,WAAW;IACX,2CAA2C;IAC3C,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gCAAgC;AACpC;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,wCAAwC;IACxC,eAAe;IACf,UAAU;IACV,0BAA0B;IAC1B,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;AAC/C;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".signin_navigation {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    padding: 10px 20px;\n    width: 50%;\n    margin: auto;\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.signin_active {\n    position: relative;\n    /* OBLIGATOIRE */\n    color: var(--couleur-secondaire);\n}\n\n.signin_active::after {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    bottom: -6px;\n    width: 80%;\n    height: 3px;\n    background-color: var(--couleur-secondaire);\n    transform: translateX(-50%);\n}\n\n.signin_welcome {\n    text-align: center;\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n\n.signign_welcom h1 {\n    font-size: 32px;\n    font-weight: 700;\n    color: var(--couleur-dark);\n}\n\n.signin_welcome p {\n    font-size: 16px;\n    margin-bottom: 10px;\n    color: var(--couleur-principale);\n}\n\n\n.signin_social_buttons {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 20px;\n}\n\n.signin_social_buttons button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    padding: 10px;\n    border-radius: 10px;\n    border: solid 1px var(--gris-secondaire);\n    background-color: var(--gris-secondaire);\n    cursor: pointer;\n    width: 50%;\n    color: var(--couleur-dark);\n    height: 58px;\n    border-radius: 100px;\n    font-size: 16px;\n    font-weight: 400;\n}\n\n.signin_social_buttons button img {\n    width: 20px;\n    height: 20px;\n}\n\n.signin_form {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    width: 50%;\n    margin: auto;\n}\n\n.signin_form p,\nspan {\n    font-size: 14px;\n    color: var(--couleur-dark);\n    margin-left: 10px;\n    font-weight: 400;\n}\n\n.signin_radio_group {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    align-items: center;\n    width: 50%;\n}\n\n.signin_input_text {\n    padding: 15px;\n    border-radius: 100px;\n    border: solid 1px var(--gris-principale);\n    font-size: 16px;\n}\n\n.sigin_validate {\n    background-color: var(--couleur-principale);\n    border: solid 2px var(--couleur-principale);\n    border-radius: 100px;\n    padding: 10px;\n    color: var(--white-principale);\n    margin-top: 20px;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n.sigin_validate:hover {\n    background-color: var(--couleur-secondaire);\n    border: solid 2px var(--couleur-secondaire);\n}\n\n.signin_hr {\n    width: 50%;\n    color: var(--couleur-dark);\n    margin: auto;\n    margin-bottom: 40px;\n    margin-top: 40px;\n}\n\n.signin_icon_x {\n    position: absolute;\n    top: 40px;\n    right: 100px;\n    font-size: 28px;\n    color: var(--couleur-secondaire);\n}\n\ninput[type=\"radio\"] {\n    transform: scale(1.4);\n    cursor: pointer;\n    accent-color: var(--couleur-secondaire);\n}\n\n@media (max-width: 769px) {\n    .signin_navigation {\n        width: 100%;\n    }\n    .signin_navigation div{\n        margin: 5px;\n    }\n    .signin_social_buttons button {\n        width: 100%;\n    }\n\n    .signin_form {\n        width: 100%;\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n\n    .signin_icon_x {\n        top: 5px;\n        right: 5px;\n    }\n}\n\n@media (max-width: 992px) {\n    .signin_navigation {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
